import { CardContent } from '@mui/material'
import { Spacer, Item } from '../../styles'
import { useTranslation } from 'react-i18next'
import React from 'react'
import { StyledView, StyledTypography } from './styles'
import { formatBooleanValue } from '../../../../../services/utils/formatters'

/**
 * A component that displays the user's banking and payment information
 *
 * @param {object} contract - Contains the user's contract data from the new API
 * @param {object} contract.paymentDetails - The payment details section of the contract
 * @param {string} contract.paymentDetails.creditInstituteName - Name of the user's bank
 * @param {string} contract.paymentDetails.bic - Bank Identifier Code
 * @param {string} contract.paymentDetails.iban - International Bank Account Number
 * @param {string} contract.paymentDetails.accountHolderName - Name of the account holder
 * @param {boolean} contract.paymentDetails.sepaAccepted - Whether user accepted SEPA terms
 * @param {string} contract.paymentDetails.paymentMethod - Payment method type (BANK_TRANSFER, SEPA, etc.)
 */
function BankInformation({ contract }) {
  const { t } = useTranslation()

  return (
    <>
      <StyledView>
        <CardContent>
          <StyledTypography fontWeight="bold" variant="h4" gutterBottom>
            {t('LBLAccountData')}
          </StyledTypography>
          <Spacer mb={4} />
          <StyledTypography variant="body2" component="div" gutterBottom>
            {/* Bank Name field */}
            <Item>
              <StyledTypography fontWeight="fontWeightMedium">
                {t('LBLBankName')}
              </StyledTypography>
              <StyledTypography fontWeight="fontWeightRegular" align="right">
                {contract?.paymentDetails?.creditInstituteName || '--'}
              </StyledTypography>
            </Item>

            {/* BIC field */}
            <Item>
              <StyledTypography fontWeight="fontWeightMedium">
                {t('LBLBic')}
              </StyledTypography>
              <StyledTypography fontWeight="fontWeightRegular" align="right">
                {contract?.paymentDetails?.bic || '--'}
              </StyledTypography>
            </Item>

            {/* IBAN field */}
            <Item>
              <StyledTypography fontWeight="fontWeightMedium">
                {t('LBLIban')}
              </StyledTypography>
              <StyledTypography fontWeight="fontWeightRegular" align="right">
                {contract?.paymentDetails?.iban || '--'}
              </StyledTypography>
            </Item>

            {/* SEPA Accept field */}
            <Item>
              <StyledTypography fontWeight="fontWeightMedium">
                {t('LBLAcceptCondition')}
              </StyledTypography>
              <StyledTypography fontWeight="fontWeightRegular" align="right">
                {contract?.paymentDetails?.sepaAccepted !== undefined
                  ? formatBooleanValue(contract.paymentDetails.sepaAccepted, t)
                  : '--'}
              </StyledTypography>
            </Item>

            {/* Account Holder field */}
            <Item>
              <StyledTypography fontWeight="fontWeightMedium">
                {t('LBLAccountHolder')}
              </StyledTypography>
              <StyledTypography fontWeight="fontWeightRegular" align="right">
                {contract?.paymentDetails?.accountHolderName || '--'}
              </StyledTypography>
            </Item>

            {/* Payment Method field */}
            <Item>
              <StyledTypography fontWeight="fontWeightMedium">
                {t('LBLPaymentMethod')}
              </StyledTypography>
              <StyledTypography fontWeight="fontWeightRegular" align="right">
                {contract?.paymentDetails?.paymentMethod
                  ? t(contract.paymentDetails.paymentMethod)
                  : '--'}
              </StyledTypography>
            </Item>
          </StyledTypography>
        </CardContent>
      </StyledView>
    </>
  )
}

export default BankInformation
